import './comparison-table.scss';

export { default as ComparisonTable } from './ComparisonTable';
export { default as ComparisonTableHeader } from './ComparisonTableHeader';
export { default as ComparisonTableHeaderCell } from './ComparisonTableHeaderCell';
export { default as ComparisonTableCategory } from './ComparisonTableCategory';
export { default as ComparisonTableFeatureRow } from './ComparisonTableFeatureRow';
export { default as ComparisonTableFeatureCell } from './ComparisonTableFeatureCell';
export { default as ComparisonTableFooter } from './ComparisonTableFooter';
export { default as ComparisonTableFooterCell } from './ComparisonTableFooterCell';
